function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.264,23.062c5.973,0,10.812-4.841,10.812-10.812c0-5.971-4.841-10.812-10.812-10.812C6.294,1.438,1.453,6.28,1.453,12.25 C1.453,18.222,6.293,23.062,12.264,23.062z M14.904,11.446l-5.75-5.805C8.939,5.44,8.85,5.136,8.925,4.852 c0.074-0.283,0.299-0.507,0.584-0.578c0.285-0.07,0.58,0.021,0.781,0.237l7.105,7.175c0.312,0.314,0.312,0.818,0,1.132l-7.107,7.176 c-0.199,0.215-0.496,0.303-0.779,0.232c-0.287-0.072-0.512-0.293-0.584-0.578c-0.074-0.285,0.015-0.587,0.228-0.788l5.75-5.805 c0,0,0.545-0.514,0.545-0.846C15.447,11.876,14.904,11.446,14.904,11.446z"
});

var SvgForwardArrow = function SvgForwardArrow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    width: "24.531px",
    height: "24.5px",
    viewBox: "0 0 24.531 24.5",
    enableBackground: "new 0 0 24.531 24.5",
    xmlSpace: "preserve",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgForwardArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/forward-arrow.934c34b2.svg";
export { ForwardRef as ReactComponent };